import PropTypes from 'prop-types'
import React, { useState, useRef, useEffect } from "react"
import { connect, useDispatch } from "react-redux"
import { useNavigate, useLocation, Link } from "react-router-dom"

// Reactstrap - no longer used for empresa dropdown, kept for other potential usage
import { } from "reactstrap"

// Import menuDropdown
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import QaBanner from "../CommonForBoth/QaBanner"
import ApiEnvSwitcher from "../CommonForBoth/ApiEnvSwitcher"

//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
  setEmpresaSeleccionada,
  fetchEmpresas,
} from "../../store/actions"

/* ── Route labels for breadcrumb ── */
const routeLabels = {
  "/portal": "Dashboard",
  "/portal/consultar-empresas": "Consultar Empresas",
  "/portal/consultar-comprobantes": "Consultar Comprobantes",
  "/portal/reporte-faltantas": "Folios Faltantes",
  "/portal/analisis-ventas": "Análisis de Ventas",
  "/portal/medios-pagos": "Medios de Pago",
  "/portal/terceros": "Terceros",
  "/portal/impuestos-generales": "Impuestos Generales",
  "/portal/analisis-articulos": "Análisis Artículos",
  "/portal/perfil-cliente": "Perfil Cliente",
  "/portal/mapa-consumo": "Mapa de Consumo",
  "/portal/envio-correos/analisis": "Análisis de envíos",
  "/portal/envio-correos/errores": "Errores por emisor",
  "/portal/envio-correos/reenvio-masivo": "Reenvío masivo",
  "/portal/envio-correos/bandeja": "Bandeja de envíos",
  "/portal/envio-correos/reportes": "Reportes de entregabilidad",
  "/portal/presupuestos": "Mis presupuestos",
  "/portal/presupuestos/nuevo": "Nuevo presupuesto",
  "/portal/presupuestos/comparativo": "Comparativo vs Ventas",
  "/portal/registro": "Registrar Usuario",
  "/portal/usuarios": "Listar Usuarios",
  "/portal/roles": "Roles y Permisos",
  "/portal/menus": "Gestión de Menús",
}

/* ── Navigation structure ── */
const navItems = [
  {
    label: "Dashboard",
    icon: "mdi-view-dashboard-outline",
    to: "/portal",
  },
  {
    label: "Empresa",
    icon: "mdi-office-building-outline",
    children: [
      { label: "Consultar Empresas", to: "/portal/consultar-empresas" },
    ],
  },
  {
    label: "Comprobantes",
    icon: "mdi-file-document-outline",
    children: [
      { label: "Consultar Comprobantes", to: "/portal/consultar-comprobantes" },
      { label: "Reporte Folios Faltantes", to: "/portal/reporte-faltantas" },
      { label: "Análisis de Ventas", to: "/portal/analisis-ventas" },
      { label: "Análisis Medios de Pago", to: "/portal/medios-pagos" },
      { label: "Análisis Ventas X Terceros", to: "/portal/terceros" },
    ],
  },
  {
    label: "Impuestos",
    icon: "mdi-calculator-variant-outline",
    children: [
      { label: "Impuestos Globales", to: "/portal/impuestos-generales" },
    ],
  },
  {
    label: "Inventarios",
    icon: "mdi-package-variant-closed",
    children: [
      { label: "Análisis Artículos", to: "/portal/analisis-articulos" },
    ],
  },
  {
    label: "Mercadeo",
    icon: "mdi-bullhorn-outline",
    children: [
      { label: "Perfil Cliente", to: "/portal/perfil-cliente" },
      { label: "Mapa de Consumo", to: "/portal/mapa-consumo" },
    ],
  },
  {
    label: "Envío de correos",
    icon: "mdi-email-fast-outline",
    children: [
      { label: "Análisis", to: "/portal/envio-correos/analisis" },
      { label: "Errores por emisor", to: "/portal/envio-correos/errores" },
      { label: "Reenvío masivo", to: "/portal/envio-correos/reenvio-masivo" },
      { label: "Bandeja de envíos", to: "/portal/envio-correos/bandeja" },
      { label: "Reportes de entregabilidad", to: "/portal/envio-correos/reportes" },
    ],
  },
  {
    label: "Presupuestos",
    icon: "mdi-target",
    children: [
      { label: "Mis presupuestos", to: "/portal/presupuestos" },
      { label: "Nuevo presupuesto", to: "/portal/presupuestos/nuevo" },
      { label: "Comparativo vs Ventas", to: "/portal/presupuestos/comparativo" },
    ],
  },
  {
    label: "Usuarios",
    icon: "mdi-account-group-outline",
    children: [
      { label: "Listar Usuarios", to: "/portal/usuarios" },
      { label: "Registrar Usuario", to: "/portal/registro" },
    ],
  },
  {
    label: "Seguridad",
    icon: "mdi-shield-lock-outline",
    children: [
      { label: "Roles y Permisos", to: "/portal/roles" },
      { label: "Gestión de Menús", to: "/portal/menus" },
    ],
  },
]

const Header = (props) => {
  const { user, empresaSeleccionada, empresas } = props;
  const [empresaMenu, setEmpresaMenu] = useState(false)
  const [mobileNavOpen, setMobileNavOpen] = useState(false)
  const [openDropdown, setOpenDropdown] = useState(null)
  const [searchTerm, setSearchTerm] = useState("")
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const empresaDropdownRef = useRef(null)
  const empresaInputRef = useRef(null)

  // Close empresa dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (empresaDropdownRef.current && !empresaDropdownRef.current.contains(e.target)) {
        setEmpresaMenu(false)
        setSearchTerm("")
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  // Cargar empresas si están vacías (ej: después de refresh de página o token)
  useEffect(() => {
    if (user && (!empresas || empresas.length === 0)) {
      dispatch(fetchEmpresas())
    }
  }, [user, empresas, dispatch])

  // Auto-focus search input when dropdown opens
  useEffect(() => {
    if (empresaMenu && empresaInputRef.current) {
      setTimeout(() => empresaInputRef.current.focus(), 50)
    }
  }, [empresaMenu])

  const currentLabel = routeLabels[location.pathname] || "Página"

  const handleEmpresaChange = (empresa) => {
    dispatch(setEmpresaSeleccionada(empresa, navigate))
    setEmpresaMenu(false)
    setSearchTerm("")
  }

  const filteredEmpresas = (empresas || []).filter(empresa =>
    empresa.nombre?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    empresa.nit?.includes(searchTerm)
  )

  // User initials
  const userName = user?.nombre || user?.name || "Usuario"
  const initials = userName
    .split(" ")
    .map(n => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2)

  // Check if a nav item or its children match the current path
  const isActive = (item) => {
    if (item.to && location.pathname === item.to) return true
    if (item.children) return item.children.some(c => location.pathname === c.to)
    return false
  }

  return (
    <React.Fragment>
      <QaBanner />
      <header id="page-topbar">
        {/* Row 1: Brand + Breadcrumb + User info */}
        <div className="navbar-header erp-topbar-row1">
          {/* Left: Brand + breadcrumb */}
          <div className="erp-topbar-left">
            {/* Brand */}
            <Link to="/portal" className="erp-topbar-brand">
              <div className="erp-brand-icon">
                <i className="mdi mdi-chart-box-outline"></i>
              </div>
              <span className="erp-brand-text d-none d-sm-inline">LS-DA</span>
            </Link>

            <span className="erp-topbar-divider d-none d-md-block"></span>

            {/* Breadcrumb */}
            <div className="erp-topbar-breadcrumb d-none d-md-flex">
              <i className="mdi mdi-home-outline"></i>
              <span className="erp-bc-sep">›</span>
              <span className="erp-bc-current">{currentLabel}</span>
            </div>
          </div>

          {/* Right: Empresa + Notifications + User */}
          <div className="erp-topbar-right">
            {/* ── Selector de entorno de datos (Prod/QA) ── */}
            <ApiEnvSwitcher />

            {/* ── Acceso al portal de Nómina (abre en pestaña nueva) ── */}
            <a
              href="https://nom.ls-da.com/"
              target="_blank"
              rel="noopener noreferrer"
              title="Abrir el portal de Nómina en una pestaña nueva"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                border: "1px solid #c7d2fe",
                borderRadius: 8,
                padding: "6px 12px",
                marginRight: 8,
                backgroundColor: "#eef2ff",
                color: "#4f46e5",
                fontWeight: 600,
                fontSize: "0.82rem",
                textDecoration: "none",
                whiteSpace: "nowrap",
              }}
            >
              <i className="mdi mdi-account-cash" style={{ fontSize: 16 }} />
              <span className="d-none d-md-inline">Nómina</span>
              <i className="mdi mdi-open-in-new" style={{ fontSize: 12 }} />
            </a>

            {/* Empresa selector with search */}
            <div ref={empresaDropdownRef} style={{ position: "relative" }} className="d-none d-sm-inline-block">
              <button
                className="erp-empresa-badge"
                onClick={() => setEmpresaMenu(!empresaMenu)}
              >
                {empresaSeleccionada?.logoUrl ? (
                  <img src={empresaSeleccionada.logoUrl} alt="" style={{ width: 22, height: 22, objectFit: "contain", borderRadius: 4 }} onError={e => { e.target.style.display = "none" }} />
                ) : (
                  <i className="mdi mdi-office-building-outline erp-empresa-icon" />
                )}
                <span className="erp-empresa-name">
                  {empresaSeleccionada?.nombre || "Seleccionar empresa"}
                </span>
                <i className={`mdi mdi-chevron-${empresaMenu ? "up" : "down"}`} style={{ fontSize: 12, color: "#8492a6" }} />
              </button>

              {empresaMenu && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    right: 0,
                    marginTop: 4,
                    width: 360,
                    backgroundColor: "#fff",
                    borderRadius: 10,
                    boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
                    border: "1px solid #e2e8f0",
                    zIndex: 1050,
                    overflow: "hidden",
                  }}
                >
                  {/* Search input */}
                  <div style={{ padding: "12px 14px 8px" }}>
                    <div style={{ position: "relative" }}>
                      <i className="mdi mdi-magnify" style={{
                        position: "absolute", left: 10, top: "50%",
                        transform: "translateY(-50%)", color: "#94a3b8", fontSize: 18,
                      }} />
                      <input
                        ref={empresaInputRef}
                        type="text"
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        placeholder="Buscar empresa..."
                        style={{
                          width: "100%", padding: "8px 12px 8px 36px",
                          border: "1px solid #e2e8f0", borderRadius: 8,
                          fontSize: "0.85rem", outline: "none",
                          backgroundColor: "#f8fafc",
                        }}
                        onFocus={e => { e.target.style.borderColor = "#556ee6" }}
                        onBlur={e => { e.target.style.borderColor = "#e2e8f0" }}
                      />
                    </div>
                  </div>

                  {/* Empresa list */}
                  <div style={{ maxHeight: 320, overflowY: "auto", padding: "0 6px 8px" }}>
                    {filteredEmpresas.length > 0 ? (
                      filteredEmpresas.map(empresa => {
                        const isActive = empresaSeleccionada?.id === empresa.id
                        return (
                          <div
                            key={empresa.id}
                            onClick={() => handleEmpresaChange(empresa)}
                            style={{
                              display: "flex", alignItems: "center", gap: 10,
                              padding: "9px 10px", borderRadius: 8, cursor: "pointer",
                              backgroundColor: isActive ? "#eef2ff" : "transparent",
                              transition: "background-color 0.15s",
                            }}
                            onMouseEnter={e => { if (!isActive) e.currentTarget.style.backgroundColor = "#f1f5f9" }}
                            onMouseLeave={e => { if (!isActive) e.currentTarget.style.backgroundColor = isActive ? "#eef2ff" : "transparent" }}
                          >
                            {empresa.logoUrl ? (
                              <img src={empresa.logoUrl} alt="" style={{ width: 28, height: 28, objectFit: "contain", borderRadius: 6, flexShrink: 0 }} onError={e => { e.target.style.display = "none" }} />
                            ) : (
                              <div style={{
                                width: 28, height: 28, borderRadius: 6,
                                background: isActive ? "#003366" : "#eef0f4",
                                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                              }}>
                                <span style={{ fontSize: 11, fontWeight: 700, color: isActive ? "#fff" : "#5a6577" }}>
                                  {empresa.nombre?.charAt(0)?.toUpperCase()}
                                </span>
                              </div>
                            )}
                            <div style={{ overflow: "hidden", flex: 1 }}>
                              <div style={{
                                fontWeight: isActive ? 700 : 500, fontSize: "12.5px",
                                whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                                color: isActive ? "#556ee6" : "#1e293b",
                              }}>
                                {empresa.nombre}
                              </div>
                              <small style={{ color: "#94a3b8", fontSize: "10px" }}>
                                NIT: {empresa.nit}{empresa.digVerificacion ? `-${empresa.digVerificacion}` : ""}
                              </small>
                            </div>
                            {isActive && (
                              <i className="mdi mdi-check-circle" style={{ color: "#1b7a4b", fontSize: 14 }} />
                            )}
                          </div>
                        )
                      })
                    ) : (
                      <div style={{ padding: "16px 10px", textAlign: "center", color: "#94a3b8", fontSize: "0.85rem" }}>
                        <i className="mdi mdi-magnify-close font-size-20 d-block mb-1" />
                        No se encontraron empresas
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* User section with profile dropdown */}
            <div className="d-flex align-items-center" style={{ borderLeft: "1px solid var(--erp-border, #e2e8f0)", paddingLeft: 12 }}>
              <div style={{ width: 28, height: 28, borderRadius: "50%", background: "#003366", display: "flex", alignItems: "center", justifyContent: "center", marginRight: 6, pointerEvents: "none" }}>
                <span style={{ color: "#fff", fontSize: 11, fontWeight: 700 }}>{initials}</span>
              </div>
              <span className="d-none d-md-inline" style={{ fontWeight: 600, fontSize: "0.82rem", color: "#1e293b", marginRight: 2, pointerEvents: "none" }}>{userName}</span>
              <ProfileMenu />
            </div>
          </div>
        </div>

        {/* Row 2: Horizontal Navigation */}
        <nav className="erp-topnav">
          {/* Mobile toggle */}
          <button
            className="erp-nav-toggle d-lg-none"
            onClick={() => setMobileNavOpen(!mobileNavOpen)}
          >
            <i className="mdi mdi-menu"></i>
            <span>Menú</span>
          </button>

          {/* Navigation items */}
          <ul className={`erp-nav-list ${mobileNavOpen ? "erp-nav-open" : ""}`}>
            {navItems.map((item, idx) => (
              <li
                key={idx}
                className={`erp-nav-item ${item.children ? "erp-has-children" : ""} ${isActive(item) ? "erp-nav-active" : ""}`}
                onMouseEnter={() => item.children && setOpenDropdown(idx)}
                onMouseLeave={() => item.children && setOpenDropdown(null)}
              >
                {item.to ? (
                  <Link
                    to={item.to}
                    className="erp-nav-link"
                    onClick={() => setMobileNavOpen(false)}
                  >
                    <i className={`mdi ${item.icon}`}></i>
                    <span>{item.label}</span>
                  </Link>
                ) : (
                  <span className="erp-nav-link" onClick={() => {
                    // On mobile, toggle dropdown on click
                    if (window.innerWidth < 992) {
                      setOpenDropdown(openDropdown === idx ? null : idx)
                    }
                  }}>
                    <i className={`mdi ${item.icon}`}></i>
                    <span>{item.label}</span>
                    <i className="mdi mdi-chevron-down erp-nav-arrow"></i>
                  </span>
                )}

                {item.children && (
                  <ul className={`erp-nav-dropdown ${openDropdown === idx ? "erp-dropdown-open" : ""}`}>
                    {item.children.map((child, cidx) => (
                      <li key={cidx}>
                        <Link
                          to={child.to}
                          className={`erp-nav-dropdown-link ${location.pathname === child.to ? "erp-dropdown-active" : ""}`}
                          onClick={() => {
                            setMobileNavOpen(false)
                            setOpenDropdown(null)
                          }}
                        >
                          {child.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
  user: PropTypes.object,
  empresaSeleccionada: PropTypes.object,
  empresas: PropTypes.array,
}

const mapStatetoProps = state => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout
  return {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
    user: state.Login.user,
    empresaSeleccionada: state.Login.empresaSeleccionada,
    empresas: state.Login.empresas,
  }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))